import { useNavigate } from 'react-router-dom';
import { Icon, TIconNames } from 'components/Base/Icon';
import ButtonDropdown from 'components/Base/ButtonDropdown';
import { Colors } from 'core/CssVariables';
import { useSignOutMutation } from 'redux/apiSlice/auth.slice';
import { RoutesPaths } from 'routes/Routes.types';
import { SHeader, SHeaderRight } from '../Layout.styles';
import { THeaderProps } from '../Layout.types';
import Button from 'components/Base/Button';
import ProfilePicture from './ProfilePicture';
import { useAppDispatch } from 'redux/store';

const Header = ({ isCollapsed, onSiderOpen }: THeaderProps) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [signOut] = useSignOutMutation();

  const handleLogout = async () => {
    await signOut();
    dispatch({ type: 'USER_LOGOUT' });
    navigate('/login');
  };

  const handleProfileClick = () => {
    navigate(`/app/${RoutesPaths.PROFILE}`);
  };

  const dropdownItems = [
    {
      key: 'logout',
      name: 'Log out',
      selected: false,
    },
  ];

  const onClickItem = (key: string) => {
    if (key === 'logout') {
      handleLogout();
    }
  };

  return (
    <SHeader>
      <div>
        {isCollapsed && (
          <Icon onClick={onSiderOpen} icon={TIconNames.MENU} size={18} />
        )}
      </div>
      <SHeaderRight>
        <Button type="text" onClick={handleProfileClick}>
          <ProfilePicture />
        </Button>
        <ButtonDropdown items={dropdownItems} onClickItem={onClickItem}>
          <Icon
            icon={TIconNames.ARROW_DROPDOWN}
            size={18}
            color={Colors.Black}
            className="mx-2"
          />
        </ButtonDropdown>
      </SHeaderRight>
    </SHeader>
  );
};

export default Header;
